// extracted by mini-css-extract-plugin
export var content = "styles-module--content--8adff";
export var latestBlogItems = "styles-module--latestBlogItems--6a20d";
export var title = "styles-module--title--2fdbc";